import { TypePatient } from '@/interfaces/patient';
import { IPrescriptionBase } from '@/interfaces/prescription-base';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import { ListaProdutosParm, UnidadeMedidaProdCalcParm } from './product';

export default interface IPrescriptionTemplate extends IPrescriptionBase {
  codigo: string;
  nome: string;
  tipoPrescricao: TypePrescricaoTemplate;
  termo: string;
  tipoPaciente: TypePatient;
  peso: string;
  ativo: boolean;
  unidadesCliente: any[];
  padroesTemplate: any[];
  modelosBolsasMulti: any[];
}

export class TemplateValidacaoParmDTO extends ListaProdutosParm {
  tipoPaciente: string;
  termoPaciente: string;
  volumeBolsaMl: number;

  public load(model: PrescriptionTemplateModel) {
    super.loadProdutos(model.produtos);
    this.tipoPaciente = model.tipoPaciente;
    this.termoPaciente = model.termo;
    this.volumeBolsaMl = model.volumeDesejado ? Number(model.volumeDesejado) : null;
  }
}

export type TypePrescricaoTemplate = 'PERFIL' | 'PADRAO';


export class TemplateParmDTO extends ListaProdutosParm {
  id: number;
  codigo: string;
  nome: string;
  tipoPaciente: string;
  termo: string;
  ativo: boolean;
  volumeDesejado: number;
  idsUnidadesCliente: number[];
  idsValorParametrosPadroes: number[];
  idsModelosBolsasMulti: number[];

  public load(model: PrescriptionTemplateModel) {
    super.loadProdutos(model.produtos);
    this.id = model.id ? Number(model.id) : null;
    this.codigo = model.codigo;
    this.nome = model.nome;
    this.tipoPaciente = model.tipoPaciente;
    this.termo = model.termo;
    this.ativo = model.ativo;
    this.volumeDesejado = model.volumeDesejado ? Number(model.volumeDesejado) : null;
    this.idsUnidadesCliente = model.unidadesCliente.map(uc => Number(uc.id));
    this.idsValorParametrosPadroes = model.padroesTemplate.map(v => Number(v.id));
    this.idsModelosBolsasMulti = model.modelosBolsasMulti.map(v => v.id);
  }
}
